module.exports = __webpack_public_path__ + "static/media/autotone_after.b777afca.png";